import React, { useEffect, useState } from "react";
import adminDefaultImg from "../images/male-icon.png";
import { Link } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import { connect } from "react-redux";
import { logoutAction } from "../actions/loginAction";
//import defaultValues from "../constant/defaultValues";
import { includes, isEmpty } from "lodash";
import Emitter from "../utils/Emitter";
import roles from "@/constant/roles.config";
import { buildPath, setAuthHeaders, showSuccessMessage } from "@/utils/common";
import { privateRoutePaths } from "@/routes/private.route.config";
import MediumPopup from "@/components/MediumPopup";
import axiosInstance from "@/axiosHttp";
import API_URL from "@/constant/api.config";
import { ToastContainer } from "react-toastify";
import Tooltips from "./Tooltips";
import { useNavigate } from 'react-router-dom';

function TopMenu(props) {
  const {
    isSuperAdmin,
    isEndUser,
    memberCompanyID,
    logout,
    user,
    company_plan,
    isPreKYCUser,
    company_status,
    view_credits,
    isViewer,
    isDemoUser,
    isOpUser,
    is_expired,
    isAdmin
  } = useAuth();

  // const { IMAGE_PATH } = defaultValues;
  // const account =
  //  user && user.company_logo
  //  ? IMAGE_PATH.BASE_URL + "/company_logo/" + user.company_logo
  //  : adminDefaultImg;
  const nav = useNavigate();
  const account = adminDefaultImg;



  const [c_status, setCompanyStatus] = useState(-1);
  const [inCompleteProfile, setInCompleteProfile] = useState(false);
  const [viewCredits, setViewCredits] = useState(null);
  const [expiredPlanShow, setExpiredPlanShow] = useState(false);

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    if (user && isAdmin) return roles.ADMIN.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const handleExpiredPlan = (type) => {
      if (type !== 'SUPPLIER') {
        setExpiredPlanShow(true);
      } else {
        planUpgradeRequestAPI(type);
      }
  }

  const planUpgradeRequestAPI = async (type) => {
    let data = {
      member_id: memberCompanyID
    }

    const headers = setAuthHeaders();
    const response = await axiosInstance.post(API_URL + "/member/upgrade-plan-request", data, {
      headers
    });
    if (response) {
      if (response.data) {
         setExpiredPlanShow(false);
        if(type !== 'SUPPLIER') {
          showSuccessMessage("We have received your upgrade request. Our team will contact you soon.")
        } else {
            setTimeout(() => {
              nav(`/${getPrefix()}${buildPath(privateRoutePaths.ADMIN_CHOOSE_PLAN, { id: memberCompanyID })}`);
            }, 500);
        } 
      }
    }
  }

  const submitPlanRequest = async () => {
     planUpgradeRequestAPI('LOG_PTR');
  }
  useEffect(() => {
    // console.log("props.company_info ======== ", props);
    if (!isEmpty(props.company_info)) {
      setCompanyStatus(props.company_info.status);
      if (!includes([1, 3, 10], props.company_info.status)) {
        setInCompleteProfile(true);
      } else {
        setInCompleteProfile(false);
      }
    } else {
      if (!isEmpty(user) && !isEmpty(user.company_status)) {
        setCompanyStatus(user.company_status);
        if (!includes([1, 3, 10], user.company_status)) {
          setInCompleteProfile(true);
        } else {
          setInCompleteProfile(false);
        }
      }
    }


  }, [props.company_info, props.company_info.status, isPreKYCUser, props]);

  const manageCompanyStatus = () => {
    if (!isEmpty(props.company_info)) {
      setCompanyStatus(props.company_info.status);
      if (!includes([1, 3, 10], props.company_info.status)) {
        setInCompleteProfile(true);
      } else {
        setInCompleteProfile(false);
      }
    } else {
      if (!isEmpty(user) && !isEmpty(user.company_status)) {
        setCompanyStatus(user.company_status);
        if (!includes([1, 3, 10], user.company_status)) {
          setInCompleteProfile(true);
        } else {
          setInCompleteProfile(false);
        }
      }
    }
  }

  const Logout = async (e) => {
    await props
      .logoutAct()
      .then((response) => {
        if (response === true) {
          logout();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateCredit = (id) => {
    console.log("updateCredit Event triggered");
    const savedUser = localStorage.getItem("user");
    let userInfo = savedUser ? JSON.parse(savedUser) : null;
    if (userInfo) {
      setViewCredits(userInfo.view_credits);
    }
  }

  useEffect(() => {
    Emitter.on("UPDATE_COMPANY_PROFILE_STATUS", manageCompanyStatus);
  })

  useEffect(() => {
    Emitter.on("CREDIT_UPDATED", updateCredit);
  })

  useEffect(() => {
    setViewCredits(view_credits);
  }, [view_credits]);

  return (
    <div>
      <div className="bg-white p-2 topmenut-nav">
        <div className="d-flex justify-content-between mx-3">
          <div className="col-xxl-4 d-flex align-items-center">
            <i
              className="fa-solid fa-bars fs-3"
              onClick={() => {
                props.collapseSidebar();
              }}
            ></i>

            {/* <div className="form-group">
                                    <input type="email" className="form-control border-0 nav-input-search" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="" />
                                </div> */}
          </div>

          <div className="col-xxl-8  d-flex align-items-center justify-content-end ">
            {/* <i className="fa-regular fa-bell text-danger fs-4 mx-3"></i> */}
            {
              isPreKYCUser && inCompleteProfile && <div className="d-flex justify-content-end">
                <div className="list-group">

                  <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: memberCompanyID })}`} className="rounded">
                    <p className="list-group-item list-group-item-danger text-center">
                      Complete Your Profile
                    </p>
                  </Link>



                </div>
              </div>
            }
            {
              (isEndUser) && <div className="d-flex flex-column align-items-end">
                <span className="top-company-name-text">{user && user.company_name}</span>
                       { isEndUser && company_plan != null && 
                       <div className="dropdown daily-credit-dropdown">
                         <button className="daily-credit-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                <p className="text-end">Daily View Credits :<b className="credit-count"> {viewCredits && viewCredits.total_credits}</b> </p>
                         </button>
                        
                        <ul className="dropdown-menu dropdown-menu-end daily-credit-menu">
                            <div className="daily-credit-header">
                                  <div className="dropdown-header">
                                     Daily View Credits
                                   </div>
                            </div>
                         <li className="py-2 dropdown-menu-border">
  <div className="dropdown-item credit-item">

    <span className="credit-item-icon">
      <svg id="fi_18945846" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m495.94 325.27-88.88-129.13c-1.88-2.73-5.61-3.42-8.34-1.54l-47.61 32.77c-1.31.9-2.21 2.29-2.5 3.85-.29 1.57.06 3.18.96 4.49l8.12 11.79c-18.24 2.69-34.39.59-48.1-6.29-9.6-4.81-19.77-5.78-32.02-3.05-23.17 5.17-42.57 10.62-61.71 17.37-19.48 1.08-44.44-1.58-59.94-11.76l6.52-9.48c.9-1.31 1.25-2.93.96-4.49s-1.19-2.95-2.5-3.85l-47.61-32.77c-2.73-1.88-6.46-1.19-8.34 1.54l-88.89 129.14c-.9 1.31-1.25 2.93-.96 4.49s1.19 2.95 2.5 3.85l47.61 32.77c1.04.71 2.22 1.06 3.4 1.06 1.91 0 3.78-.91 4.95-2.6l4.88-7.09c5.82 9.62 13.66 18.92 23.73 28.15l-3.41 4.9c-7.65 10.99-4.93 26.15 6.06 33.8 3.68 2.56 7.82 3.95 11.99 4.27l-.3.42c-3.69 5.31-5.1 11.75-3.95 18.15s4.7 11.96 10.01 15.65c4.1 2.85 8.88 4.34 13.79 4.34 1.45 0 2.91-.13 4.36-.39 5.04-.9 9.54-3.32 13.04-6.89 1.77 4.07 4.61 7.58 8.33 10.17 4.1 2.85 8.88 4.34 13.79 4.34 1.45 0 2.91-.13 4.36-.39 2.61-.47 5.06-1.35 7.32-2.58 1.55 4.97 4.69 9.49 9.29 12.69 4.22 2.93 9.05 4.34 13.83 4.34 7.69 0 15.25-3.63 19.97-10.4l3.54-5.09 33.58 21.14c4.35 2.74 9.2 4.05 14 4.05 8.76 0 17.35-4.36 22.35-12.31 2.87-4.55 4.16-9.66 4.03-14.67 3.47 1.64 7.22 2.48 11.04 2.48 1.94 0 3.89-.21 5.83-.65 6.93-1.55 12.82-5.7 16.59-11.68 3.06-4.86 4.32-10.34 3.99-15.67 2.35.68 4.79 1.03 7.25 1.03 1.97 0 3.96-.22 5.93-.67 6.88-1.56 12.73-5.7 16.47-11.64 3.59-5.7 4.83-12.43 3.55-19.04.25.01.5.03.75.03 1.97 0 3.96-.22 5.93-.67 6.88-1.56 12.73-5.7 16.47-11.64 5.49-8.72 5.22-19.44.22-27.71 11.07-3.42 21.48-9.78 30.05-18.41l6.23 9.05c.9 1.31 2.29 2.21 3.85 2.5.36.07.73.1 1.09.1 1.21 0 2.39-.36 3.4-1.06l47.61-32.77c2.73-1.87 3.42-5.61 1.54-8.34zm-428.87 26.42-37.73-25.97 82.07-119.25 37.73 25.97zm61.7 58.59c-1.86 2.68-4.67 4.47-7.92 5.05-3.24.58-6.5-.12-9.18-1.99-2.68-1.86-4.47-4.67-5.05-7.92s.12-6.5 1.99-9.18l17.63-25.34c1.86-2.68 4.67-4.47 7.92-5.05 3.24-.58 6.5.12 9.18 1.99 2.68 1.86 4.47 4.67 5.05 7.92.58 3.24-.12 6.5-1.99 9.18zm9.84 43.55c-3.24.58-6.5-.12-9.18-1.99-2.68-1.86-4.47-4.67-5.05-7.92s.12-6.5 1.99-9.18l12.25-17.6s0 0 .01-.01l29.89-42.95c2.38-3.42 6.21-5.26 10.1-5.26 2.42 0 4.86.71 7 2.2 2.68 1.86 4.47 4.67 5.05 7.92s-.12 6.5-1.99 9.18l-42.14 60.56c-1.88 2.67-4.69 4.47-7.93 5.05zm39.51 7.23c-3.24.58-6.5-.12-9.18-1.99s-4.47-4.67-5.05-7.92.12-6.5 1.99-9.18l23.14-33.24c1.86-2.68 4.67-4.47 7.92-5.05 3.24-.58 6.5.12 9.18 1.99 5.56 3.87 6.93 11.54 3.07 17.1l-4.74 6.81c0 .01-.01.01-.01.02l-18.4 26.4c-1.86 2.68-4.67 4.47-7.92 5.06zm42.68 9c-3.87 5.56-11.54 6.93-17.1 3.07-5.56-3.87-6.93-11.54-3.07-17.1l13.63-19.59c3.87-5.55 11.53-6.93 17.09-3.06s6.93 11.54 3.07 17.1zm170.99-74.53c-2.03 3.23-5.22 5.47-8.98 6.33-3.75.85-7.6.21-10.83-1.83l-69.6-43.83c-2.8-1.76-6.51-.92-8.27 1.88-1.77 2.8-.92 6.51 1.88 8.27l64.6 40.67s.01.01.01.01c3.23 2.03 5.48 5.22 6.33 8.98s.2 7.6-1.83 10.83-5.22 5.47-8.98 6.33c-3.75.85-7.6.2-10.83-1.83l-11.92-7.5s-.01 0-.01-.01l-52-32.74c-2.81-1.76-6.51-.92-8.27 1.88-1.77 2.8-.92 6.51 1.88 8.27l52.01 32.75c6.69 4.22 8.7 13.1 4.49 19.8-2.05 3.26-5.27 5.52-9.06 6.37-3.73.84-7.54.18-10.72-1.84l-43.72-27.91c-2.79-1.78-6.5-.96-8.29 1.83s-.96 6.5 1.83 8.29l28.02 17.89-.06.1c6.7 4.22 8.72 13.1 4.5 19.81-4.22 6.7-13.1 8.72-19.81 4.5l-33.11-20.85 3.23-4.64c7.65-10.99 4.93-26.15-6.06-33.8-4.59-3.19-9.91-4.57-15.11-4.3 1.26-8.8-2.37-17.99-10.15-23.41-3.71-2.58-7.98-4.04-12.4-4.29 2.12-4.51 2.8-9.57 1.9-14.6-1.15-6.4-4.7-11.96-10.01-15.65-10.99-7.65-26.15-4.93-33.8 6.06l-.31.45c-1.78-3.9-4.55-7.28-8.15-9.79-5.31-3.69-11.75-5.1-18.15-3.95s-11.96 4.7-15.65 10.01l-7.31 10.5c-10.31-9.63-17.9-19.26-23.07-29.21l63.09-91.67c12.65 8.41 28.98 11.93 42.79 13.3-3.68 2.85-6.75 6.12-9.38 9.96l-21.66 31.59c-1.35 1.98-1.82 4.35-1.32 6.69s1.91 4.32 3.96 5.56c27.38 16.62 54.74 10.41 81.33-18.47.26-.28.43-.34.81-.32l27.52 1.86 114.14 71.87c6.7 4.21 8.72 13.1 4.5 19.8zm0-31.15-113.53-71.48c-.84-.53-1.8-.84-2.79-.91l-29.03-1.96c-4.01-.27-7.72 1.21-10.45 4.17-21.44 23.28-42.14 29.22-63.18 18.1l19.59-28.57c4.33-6.32 10.19-10.51 19.6-14.02 21.28-7.94 42.31-14.05 68.17-19.82 9.54-2.12 16.95-1.49 24.03 2.06 17.43 8.74 37.93 10.89 60.97 6.44l60.1 87.32c-9.18 9.92-21.09 16.59-33.48 18.67zm53.14-11.28-82.07-119.25 37.73-25.97 82.07 119.25zm-265.55-161h153.23c3.31 0 6-2.69 6-6v-131.7c0-1.23-.37-2.36-1-3.31l-22.13-33.4c-1.11-1.68-2.99-2.69-5-2.69h-108.96c-2.01 0-3.89 1.01-5 2.69l-22.11 33.36s0 .01-.01.01l-.02.03c-.63.95-1 2.09-1 3.31v131.7c0 3.32 2.69 6 6 6zm147.24-12h-141.24v-119.7h48v49.6c0 2.3 1.32 4.4 3.39 5.4 2.08 1 4.54.73 6.34-.71l12.89-10.24 12.88 10.25c1.08.86 2.4 1.31 3.74 1.31.89 0 1.78-.2 2.6-.6 2.07-1 3.39-3.1 3.39-5.4v-49.61h48v119.7zm-81.24-119.7h21.24v37.16l-6.88-5.48c-2.19-1.74-5.29-1.74-7.47 0l-6.88 5.48v-37.16zm1.14-12 3.73-21.4h11.5l3.73 21.4zm74.92 0h-43.78l-3.73-21.4h33.33zm-116.7-21.4h33.33l-3.73 21.4h-43.78z"></path></svg>
    </span>

    <div className="credit-content">
      <strong>{viewCredits && viewCredits.supplier_credits}</strong>
      <span>Supplier Credits</span>
    </div>

  </div>
</li>


<li className="py-2">
  <div className="dropdown-item credit-item">

    <span className="credit-item-icon">
     
     <svg id="fi_15558969" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m339.67 437.79c1.42 3 .14 6.57-2.86 7.99-25.36 12-52.55 18.08-80.81 18.08-23.07 0-45.61-4.11-66.99-12.21-3.1-1.17-4.66-4.64-3.49-7.74s4.64-4.66 7.74-3.49c20.02 7.58 41.13 11.43 62.74 11.43 26.47 0 51.94-5.7 75.68-16.93 2.99-1.4 6.57-.12 7.99 2.87zm-265.45-134.57c.24 0 .49-.01.74-.04 3.29-.4 5.63-3.4 5.23-6.69-.88-7.17-1.32-14.49-1.32-21.76 0-57.54 28.12-111.71 75.22-144.9 2.71-1.91 3.36-5.65 1.45-8.36s-5.65-3.36-8.36-1.45c-50.28 35.44-80.3 93.27-80.3 154.71 0 7.76.48 15.57 1.41 23.22.35 3.04 2.94 5.27 5.93 5.27zm283.7-173.39c47.1 33.19 75.22 87.36 75.22 144.9 0 5.88-.29 11.81-.87 17.63-.33 3.3 2.08 6.23 5.38 6.56.2.02.4.03.6.03 3.05 0 5.66-2.31 5.96-5.41.61-6.21.92-12.53.92-18.81 0-61.44-30.02-119.27-80.3-154.71-2.71-1.91-6.45-1.26-8.36 1.45-1.9 2.7-1.25 6.45 1.45 8.36zm-101.92 247.85c-56.77 0-102.96-46.19-102.96-102.96s46.19-102.95 102.96-102.95 102.96 46.19 102.96 102.96-46.19 102.95-102.96 102.95zm6-12.88c11.42-3.34 21.6-16 28.59-34-9.04-1.86-18.69-3-28.59-3.32zm32.4-45.43c3.28-11.62 5.34-24.77 5.81-38.65h-38.21v34.75c11.21.36 22.15 1.69 32.4 3.9zm5.81-50.64c-.47-13.88-2.53-27.03-5.81-38.65-10.25 2.21-21.19 3.55-32.4 3.9v34.75zm-9.62-50.09c-6.99-17.99-17.17-30.66-28.59-34v37.32c9.91-.32 19.55-1.45 28.59-3.32zm-40.59-33.99c-11.42 3.34-21.6 16-28.59 34 9.04 1.86 18.69 3 28.59 3.32zm-32.4 45.43c-3.28 11.62-5.34 24.77-5.81 38.65h38.21v-34.75c-11.21-.36-22.15-1.69-32.4-3.9zm-5.81 50.65c.47 13.88 2.53 27.03 5.81 38.65 10.25-2.21 21.19-3.55 32.4-3.9v-34.75zm9.62 50.08c6.99 17.99 17.17 30.66 28.59 34v-37.32c-9.91.32-19.55 1.45-28.59 3.32zm66.57 29.07c11.73-4.42 22.32-11.2 31.18-19.76-5.15-2.47-10.81-4.6-16.85-6.39-1.63 4.31-3.44 8.41-5.44 12.26-2.72 5.25-5.7 9.88-8.89 13.89zm39.52-28.99c11.02-14 18.02-31.31 19.26-50.17h-34.55c-.45 14.69-2.56 28.83-6.16 41.62 7.78 2.33 15 5.19 21.45 8.55zm19.26-62.16c-1.23-18.86-8.23-36.17-19.26-50.17-6.45 3.36-13.67 6.22-21.45 8.54 3.6 12.79 5.71 26.93 6.16 41.62h34.55zm-27.61-59.4c-8.86-8.56-19.44-15.33-31.18-19.75 3.19 4 6.17 8.64 8.89 13.88 2 3.85 3.81 7.96 5.44 12.26 6.04-1.79 11.7-3.92 16.85-6.39zm-95.13-19.75c-11.73 4.42-22.32 11.2-31.18 19.76 5.15 2.47 10.81 4.6 16.85 6.39 1.63-4.31 3.44-8.41 5.44-12.26 2.72-5.26 5.7-9.89 8.89-13.89zm-39.52 28.98c-11.02 14-18.02 31.31-19.26 50.17h34.55c.45-14.69 2.56-28.83 6.16-41.62-7.78-2.33-15-5.19-21.45-8.55zm-19.25 62.17c1.23 18.86 8.23 36.16 19.26 50.17 6.45-3.36 13.67-6.22 21.45-8.54-3.6-12.79-5.71-26.93-6.16-41.62h-34.55zm27.6 59.39c8.86 8.56 19.44 15.33 31.18 19.76-3.19-4-6.17-8.64-8.89-13.88-2-3.85-3.81-7.96-5.44-12.26-6.04 1.78-11.7 3.91-16.85 6.38zm304.15 99.89v32.27c0 3.31-2.69 6-6 6h-128.91c-3.31 0-6-2.69-6-6v-32.27c0-22.76 14.39-45.68 45.92-53.47-9.73-7.42-16.03-19.12-16.03-32.27 0-22.37 18.2-40.57 40.57-40.57s40.57 18.2 40.57 40.57c0 13.15-6.3 24.86-16.03 32.27 31.52 7.78 45.91 30.71 45.91 53.47zm-99.02-85.75c0 15.75 12.81 28.57 28.57 28.57 15.75 0 28.57-12.81 28.57-28.57s-12.81-28.57-28.57-28.57c-15.76.01-28.57 12.82-28.57 28.57zm87.02 85.75c0-26.88-22.94-44.25-58.45-44.25s-58.45 17.37-58.45 44.25v26.27h19.23v-20.86c0-3.31 2.69-6 6-6s6 2.69 6 6v20.86h54.46v-20.86c0-3.31 2.69-6 6-6s6 2.69 6 6v20.86h19.21zm-316.6-80.25v72.44c0 2.18-1.18 4.18-3.08 5.24l-70.7 39.39c-.91.51-1.91.76-2.92.76s-2.01-.26-2.92-.77v.01l-70.7-39.39c-1.9-1.06-3.08-3.07-3.08-5.24v-72.44c0-2.13 1.13-4.1 2.96-5.17.04-.02.08-.04.12-.06v-.01l70.7-39.39c1.82-1.01 4.02-1.01 5.84 0l70.7 39.39v.01c.04.02.08.04.12.06 1.83 1.08 2.96 3.05 2.96 5.17zm-87.95-26.25 55.74 33.98 13.87-7.73-58.36-32.51zm11.25 58.77 16.5-9.19-56.31-33.67-18.56 10.34zm32.45-18.08-55.74-33.98-4.41 2.46 56.31 33.67zm2.33 32.4 3.58-2.07v-19.88l-3.58 1.99zm-99.48 22.08 58.7 32.7v-58.71l-58.7-32.7zm129.4-58.71-14.34 7.99v30.03c0 2.14-1.14 4.12-3 5.19l-15.58 9.01c-.93.54-1.97.81-3 .81-1.04 0-2.07-.27-3-.8-1.86-1.07-3-3.05-3-5.2v-23.67l-16.78 9.35v58.71l58.7-32.7zm17.26-230.85v-93.31c0-6.66 5.42-12.08 12.08-12.08h84.39c6.66 0 12.08 5.42 12.08 12.08v10.76h26.92c2.03 0 3.93 1.03 5.03 2.74l23.19 35.78c.63.97.97 2.11.97 3.26v40.76c0 3.31-2.69 6-6 6h-10.43c-2.51 7.34-9.45 12.63-17.62 12.63s-15.12-5.3-17.62-12.63h-10.43-51.14c-2.51 7.34-9.45 12.63-17.62 12.63s-15.12-5.3-17.62-12.63h-10.17c-3.32.01-6.01-2.68-6.01-5.99zm40.43 0c0-3.66-2.98-6.63-6.63-6.63-3.66 0-6.63 2.98-6.63 6.63 0 3.66 2.98 6.63 6.63 6.63s6.63-2.97 6.63-6.63zm56.13-6v-18.44h-84.56v18.44h4.17c2.51-7.34 9.45-12.63 17.62-12.63s15.12 5.3 17.62 12.63zm40.7 6c0-3.66-2.98-6.63-6.63-6.63-3.66 0-6.63 2.98-6.63 6.63 0 3.66 2.98 6.63 6.63 6.63s6.63-2.97 6.63-6.63zm5.98-53.56h-11.99v6.8h16.39zm-34.68-16.99v64.54h4.43c2.51-7.34 9.45-12.63 17.62-12.63s15.12 5.3 17.62 12.63h4.43v-28.76h-27.43c-3.31 0-6-2.69-6-6v-18.8c0-3.31 2.69-6 6-6h10.21l-3.23-4.98zm-96.56-22.76v56.87h84.56v-56.87c0-.03-.05-.08-.08-.08h-84.39c-.04 0-.09.05-.09.08z"></path></svg>
    </span>

    <div className="credit-content">
      <strong>{viewCredits && viewCredits.logistics_credits}</strong>
      <span>Logistic Credits</span>
    </div>

  </div>
</li>

</ul>
    </div>
       }
        </div>
            }
            {
              isPreKYCUser && company_plan !== null && is_expired == 1 && <div className="d-flex justify-content-end">
                <div className="list-group">
                  <button onClick={()=> handleExpiredPlan(user.trade_mode_type)} className="rounded list-group-item list-group-item-danger text-center">
                    Upgrade Plan
                  </button>
                </div>
              </div>
            }

            

            <div className="nav-item navbar-dropdown dropdown-user dropdown mx-2 cursor-pointer">
              <p
                className="nav-link dropdown-toggle  nav-account-img"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {(!isSuperAdmin && !isViewer && !isOpUser && !isAdmin) && (
                  <img src={account} alt="logo" className="rounded-circle" />
                )}

                {(isSuperAdmin || isViewer || isOpUser || isAdmin) && (
                  <img
                    src={adminDefaultImg}
                    alt="logo"
                    className="rounded-circle"
                  />
                )}
                {/* {isSuperAdmin && <img src={adminDefaultImg} alt="logo" className="rounded-circle" />} */}
              </p>

              <ul className="dropdown-menu dropdown-menu-end">
                <li className="py-2 dropdown-menu-border">
                  <div className="flex-grow-1 dropdown-item ">
                    <p className="profile-name">{user && user.name}</p>
                    <p className="m-0">{user && user.email}</p>

                    {!isSuperAdmin && !isViewer && !isOpUser && !isAdmin && (
                      <p className="m-0 subscription-plan">
                        {company_plan == null ? "(Free" : "(" + company_plan} - Plan)
                      </p>
                    )}
                  </div>
                </li>

                {!isSuperAdmin && !isViewer && !isOpUser && !isAdmin && (
                  <li className="dropdown-item dropdown-menu-border py-2">
                    <Link
                      to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: memberCompanyID })}`}
                      reloadDocument
                    >
                      <span>My Profile</span>
                    </Link>
                  </li>
                )}

                {/* {!isSuperAdmin && (< li className="dropdown-item dropdown-menu-border py-2">
                                    <Link to={`/updateprofile/${memberCompanyID}`} reloadDocument>
                                        <span>{(company_plan == null) ? "Free" : company_plan} - Plan</span>
                                    </Link>
                                </li>)} */}

                <li
                  className="dropdown-item py-2 dropdown-menu-border"
                  onClick={Logout}
                >
                  {/* <button onClick={logout}>Log Out</button> */}
                  <span>
                    <i className="fa-solid fa-arrow-right-from-bracket me-1"></i>
                    Log Out{" "}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <MediumPopup
        title={"Unlock More with an Upgrade!"}
        mediummodalShow={expiredPlanShow}
        setMediumModalShow={setExpiredPlanShow}
        titlePosition="center-align-title"
        closeButtonLabel="Maybe Later"
        okButtonLabel="Request Upgrade"
        onSubmit={submitPlanRequest}
      >
        <p>You're currently on <b>{company_plan ?? 'Free'} Plan</b>, which has been expired.</p>
        <p>Upgrade your plan to continue using all features without restrictions.</p>
        <p>What you will get?</p>
        <ul className="icon">
          <li>Raise unlimited inquiries</li>
          <li>Connect with verified suppliers</li>
          <li>Access complete business features</li>
          <li>Priority support</li>
        </ul>
      </MediumPopup >
      {/* <ToastContainer /> */}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth.logout,
    company_info: state.update.updateProfile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logoutAct: () => dispatch(logoutAction()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TopMenu);
